// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shortcut-button[data-v-1c616ed8] {\n  font-size: 0.75rem;\n  width: 6.25rem;\n}", ""]);
// Exports
module.exports = exports;
